<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col class="col-md-12 col-sm-12 col-lg-12">
        <b-card>
          <div slot="header">
            ایجاد
            <strong v-text="$lang.competency"></strong>
          </div>
          <b-alert variant="danger" show dismissible v-show="errors.length > 0">
            <li v-bind:key="index" v-for="(error, index) in errors">
              {{ error }}
            </li>
          </b-alert>
          <b-form @submit.prevent="save" v-show="!isLoading">
            <b-form-group
              :label="$lang.name"
              label-for="name"
              :label-cols="this.$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.name"
                :rules="$v.name.$params"
              />
              <b-form-input
                data-testid="name"
                type="text"
                name="name"
                class="name"
                :autocomplete="$lang.name"
                :state="$v.name.$dirty ? !$v.name.$error : null"
                v-model="$v.name.$model"
              ></b-form-input>
              <b-form-invalid-feedback id="name-feedback"
                >{{ $lang.error_required | replace($lang.name) }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              :label="$lang.description"
              label-for="description"
              :label-cols="12"
            >
              <requiredComponent
                slot="label"
                :label="$lang.description"
                :rules="$v.description.$params"
              />
              <b-form-textarea
                name="description"
                data-testid="description"
                :state="$v.description.$dirty ? !$v.description.$error : null"
                v-model="$v.description.$model"
                type="text"
                :autocomplete="$lang.description"
                :rows="this.$config.form.textareaRows"
              ></b-form-textarea>
              <b-form-invalid-feedback id="description-feedback"
                >{{ $lang.error_required | replace($lang.description) }}
              </b-form-invalid-feedback>
            </b-form-group>
            <TagComponent
              category_name="competency_category"
              :label="$lang.category"
              :multiple="false"
              :parentPermissions="['admin']"
              :checkValidation="checkCompetencyCategorySelected"
              @updateCheckValidation="updateCheckCompetencyCategorySelected"
              @getSelected="getCompetencyCategorySelected"
            />
            <TagComponent
              category_name="competency_reference"
              :label="$lang.reference"
              :multiple="false"
              :parentPermissions="['admin']"
              :checkValidation="checkCompetencyReferenceSelected"
              @updateCheckValidation="updateCheckCompetencyReferenceSelected"
              @getSelected="getCompetencyReferenceSelected"
            />
            <div slot="footer" class="form-group form-btn">
              <b-button
                data-testid="submit-button"
                type="submit"
                size="md"
                variant="success"
              >
                {{ $lang.submitButton }}
                <i class="fa fa-check"></i>
              </b-button>
              <b-button
                id="cancel"
                type="reset"
                class="ml-2"
                size="md"
                variant="danger"
                @click="handleBack"
              >
                {{ $lang.cancelButton }}
                <i class="fa fa-ban"></i>
              </b-button>
            </div>
          </b-form>
          <div class="text-center" v-show="isLoading">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import TagComponent from "@/components/tag/tagComponent.vue";

/**
 * @group competency
 * این کامپوننت برای ویرایش کردن شایستگی تعریف شده است
 */
export default {
  name: "add-competency",
  inject: ["competencyRepository", "enumRepository"],
  validations: {
    name: {
      required,
    },
    description: {
      required,
    },
    category_id: {
      required,
    },
    reference_id: {
      required,
    },
  },
  components: { TagComponent },
  props: {
    // نمایانگر این است که کامپوننت بصورت مدال اجرا شده است یا فرم
    isModal: {
      type: Boolean,
      // false
      default: false,
    },
    // نمایانگر مسیر بازگشت پس از انجام یا لغو عملیات کامپوننت
    backUrl: {
      type: String,
      // null
      default: "",
    },
  },
  data() {
    return {
      isLoading: false, // دیفالت مقدار مودال false است
      name: "", // عنوان
      description: "", // توضیحات
      category_id: null, // id دسته بندی
      reference_id: null, // id مرجع
      errors: [], // لیست خطا
      checkCompetencyReferenceSelected: false,
      checkCompetencyCategorySelected: false,
    };
  },
  methods: {
    /**
     * @vuese
     *  در زمانی که مودال برای انجام فرایندی باز می شود بعد تایید در همان صفحه بماند یا به صفحه قبل خود برود
     * @arg  بدون پارامتر
     */

    handleBack() {
      if (this.isModal) {
        // برای بسته شدن مودال
        // @arg بدون پارامتر
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    /**
     * @vuese
     *  بعد از این که یک شایستگی add شد input‌ها خالی شود بای add دوباره data
     * @arg   بدون پارامتر
     */
    clear() {
      this.name = "";
      this.description = "";
      this.category_id = null;
      this.reference_id = null;
    },
    /**
     * @vuese
     * بعد از خیره داده ایا به یک route قبل خود برود یا نه
     * @arg بدون پارامتر
     */
    afterSave() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else {
        this.handleBack();
      }
    },
    /**
     * @vuese
     *    فرایند ذخیره سازی در کامپوننت جاری
     * @arg بدون پارامتر
     */
    save() {
      this.$v.$touch();
      this.checkCompetencyCategorySelected = true;
      this.checkCompetencyReferenceSelected = true;
      if (this.$v.$anyError) return;

      this.isLoading = true;
      let payload = {
        name: this.name,
        description: this.description,
        category_id: this.category_id.value,
        reference_id: this.reference_id.value,
      };

      // ایجاد شایستگی
      this.competencyRepository
        .create(payload)
        .then((response) => {
          // شایستگی  add شدند
          // @arg بدون پارامتر
          this.$emit("competency-added");
          this.$notify.success(response.data.message);
          this.$v.$reset();
          this.afterSave();
          this.$emit("getData");
        })
        .catch((err) => {
          // شایستگی  add به error دارد
          // @arg بدون پارامتر
          this.$emit("competency-error");
          if (
            err.response &&
            "status" in err.response &&
            err.response.status == 400
          ) {
            if (typeof err.response.data.message === "object") {
              err.response.data.message.forEach((element) => {
                this.errors.push(element);
              });
            } else {
              this.$notify.error(err.response.data.message);
            }
          } else {
            this.$notify.error(err.message);
          }
          this.isLoading = false;
        })
        .finally(() => {
          this.clear();
          this.isLoading = false;
        });
    },
    updateCheckCompetencyCategorySelected(data) {
      this.checkCompetencyCategorySelected = data;
    },
    updateCheckCompetencyReferenceSelected(data) {
      this.checkCompetencyReferenceSelected = data;
    },
    getCompetencyCategorySelected(data) {
      this.category_id = data;
    },
    getCompetencyReferenceSelected(data) {
      this.reference_id = data;
    },
  },
};
</script>

<style scoped lang="css">
.btn {
  margin-bottom: 4px;
}
</style>
